export interface SwitchProps {
  on: boolean
  onChange?: (next: boolean) => void
  'aria-label'?: string
}

export function Switch({ on, onChange, 'aria-label': ariaLabel }: SwitchProps) {
  return (
    <div
      className={`switch${on ? ' switch--on' : ''}`}
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      tabIndex={0}
      onClick={() => onChange?.(!on)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onChange?.(!on)
        }
      }}
    >
      <div className="switch__track" />
      <div className="switch__thumb" />
    </div>
  )
}
